// import $ from 'jquery';

// $(() => {
//   // 入力チェック
//   // 戻り値についてtrue: 未入力なし/email妥当性OK false: 未入力あり/emailが不正
//   function isActivationBulkDownload() {
//     // 利用規約チェックボックス
//     // On:  一括ダウンロードボタンを活性化
//     // Off: 一括ダウンロードボタンを非活性
//     return $('#inquiry_terms_of_use').prop('checked');
//   }
//   function setBulkDownloadDisabled() {
//     $('#inquiry').prop('disabled', !isActivationBulkDownload());
//   }
//   // 利用規約に同意
//   if ($('#inquiry_terms_of_use').length) {
//     // 利用規約のチェックボックスを変更された場合
//     $('#inquiry_terms_of_use').change(() => {
//       setBulkDownloadDisabled();
//     });
//     // 初期表示設定
//     setBulkDownloadDisabled();
//   }
// });

// [note]
//
// JavaScript側では以下のみをチェック
//
// - 必須inputにテキストが空ではないか？
// - 必須inputにテキストが空ではないか？
// - 利用規約のチェックボックスがチェックされているか？
//
// これらがtrueであれば、サブミットボタンを有効にする

class ContactRequiredApp {
  app = this;
  submitEl = document.querySelector('[data-role="contact-submit"]');
  requiredItemEls = document.querySelectorAll('[data-role="contact-required-item"]');
  requiredCkItemEl = document.querySelector('[data-role="contact-required-ck-item"]');
  canSubmit = false;

  constructor() {
    this.requiredItems = [];
    this.requiredItemEls.forEach((el) => {
      this.requiredItems.push(new ContactRequiredItem({ el, app: this.app }));
    });
    this.contactRequiredCkItem = new ContactRequiredCkItem({ el: this.requiredCkItemEl, app: this.app });

    // init
    this.validate();
  }

  enableSubmit() {
    this.submitEl.classList.remove('disabled');
    this.submitEl.querySelector('input').disabled = false;
  }

  disableSubmit() {
    this.submitEl.classList.add('disabled');
    this.submitEl.querySelector('input').disabled = true;
  }

  validate() {
    const validAllRequiredItems = this.requiredItems.every((item) => item.isValid);

    this.canSubmit = validAllRequiredItems && this.contactRequiredCkItem.isValid;

    this.render();
  }

  render() {
    if (this.canSubmit) this.enableSubmit();
    if (!this.canSubmit) this.disableSubmit();
  }
}

// input type="text" と textareaのみを暗黙で想定
class ContactRequiredItem {
  isValid = false;
  constructor(opts = {}) {
    this.el = opts.el;
    this.app = opts.app;

    // init
    if (this.el.value !== '') this.isValid = true;

    this.el.addEventListener('input', () => {
      if (this.el.value === '') this.isValid = false;
      if (this.el.value !== '') this.isValid = true;
      this.app.validate();
    });
  }
}

// 利用規約に同意のチェックボックス
class ContactRequiredCkItem {
  isValid = false;
  constructor(opts = {}) {
    this.el = opts.el;
    this.app = opts.app;

    // init
    if (this.el.checked) this.isValid = true;

    this.el.addEventListener('change', () => {
      if (!this.el.checked) this.isValid = false;
      if (this.el.checked) this.isValid = true;
      this.app.validate();
    });
  }
}

if (document.querySelector('[data-role="contact-submit"]') !== null) {
  new ContactRequiredApp();
}
